import { createMuiTheme } from '@material-ui/core/styles';

const darkGray = '#1f1f1f';
const secondaryLightGray = '#aaaaaa';
const headerGray = '#a0a0a0';
const white = '#ffffff';

export const overridings = {
  name: 'Dark Theme',
  palette: {
    type: 'dark',
    primary: {
      main: white,
      contrastText: darkGray,
    },
    secondary: {
      main: secondaryLightGray,
      contrastText: darkGray,
    },
    neutral: {
      light: '#707070',
      main: '#bcbccb',
      dark: '#a0a0a0',
    },
    header: {
      main: headerGray,
    },
    background: {
      default: '#121212',
      paper: '#1f1f1f',
    },
  },
  typography: {
    fontFamily: `"Source Sans Pro", "Roboto", "Arial", sans-serif`,
    h4: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
    },
    h5: {
      fontSize: '1.875rem',
      fontWeight: 'bold',
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 'bold',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 0,
        fontSize: '1.125em',
        textTransform: 'none',
      },
    },
    MUIDataTableToolbarSelect: {
      root: {
        display: 'none',
      },
    },
    MuiSpeedDialAction: {
      staticTooltipLabel: {
        width: 'max-content',
      },
    },
  },
};

export default createMuiTheme(overridings);
